import React, {useEffect, useState} from 'react'
import styled from 'styled-components'
//---REDUX
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import allTheActions from '../actions'
//---
import Navbar from "../components/navbar";
import Menu from "../components/menu";
import TitleH1 from "../components/titleH1";
import TitleH3 from "../components/titleH3";
import Button from "../components/button";
import MenuMember from "../components/menuMember";
import HorizontalAlign from "../components/horizontalAlign";
import Input from "../components/input";
import Swal from "sweetalert2";

const DivWhite = styled.div`
  background-color: #fff;
  box-shadow: 0px 0px 5px 0px rgba(209, 209, 209, 1);
  padding: 20px;
`

const Profile = props => {
    const [data, setData] = useState({})
    const [club, setClub] = useState({})

    const handleChangePassword = (event) => {
        setData({...data, password: event.target.value})
    }

    const handleSubmit = async (event) => {
        event.preventDefault()
        if (await props.actions.user.updateOneUser(data))
            Swal.fire(
                'Bravo !',
                `Mise à jour des informations de ${data.prenom} ${data.nom} réussie !`,
                'success'
            ).then(() => document.location.reload())
    }

    useEffect(() => {
        setData(JSON.parse(JSON.parse(localStorage.getItem('persist:3fts')).login))
    }, [])

    useEffect(() => {
        const fetchClub = async () => {
            if (data.idClub !== undefined && data.idClub !== "none") setClub(await props.actions.club.getOne(data.idClub))
        }
        fetchClub()
    }, [props.actions.club, data.idClub])

    return <div>
        <Navbar/>
        {(localStorage.getItem('admin') === 'true') ? <Menu/> : <MenuMember/>}
        <DivWhite>
            <HorizontalAlign content={
                <>
                    <div>
                        <TitleH1 content={`${data.prenom} ${data.nom}`} margin="15px 0 5px 0"/>
                        <TitleH3 content={club.nom} marginTop="0"/>
                        <TitleH3 content={data.mail} textTransform="none" marginTop="50px" marginBottom="15px"/>
                        <Input type="password" name="password" placeholder="Changer le mot de passe..."
                               onChange={handleChangePassword}/>
                        <Button onClick={handleSubmit} width="100%"/>
                    </div>
                    <Button value="Déconnexion" onClick={() => props.actions.login.logout()} marginTop="0"
                            width="auto"/>
                </>
            }/>
        </DivWhite>

    </div>
}

const mapStateToProps = state => ({
    licenceState: state.licence,
    clubState: state.club,
    loginState: state.login,
    userState: state.user
})

const mapDispatchToProps = () => dispatch => ({
    actions: {
        licence: bindActionCreators(allTheActions.licence, dispatch),
        club: bindActionCreators(allTheActions.club, dispatch),
        login: bindActionCreators(allTheActions.login, dispatch),
        user: bindActionCreators(allTheActions.user, dispatch)
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(Profile)
